// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__2hxFZ","text":"Question_text__2Cqn_","controls":"Question_controls__3y6rX","approve":"Question_approve__2_C5d","cancel":"Question_cancel__nnuCY"};